// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_i-z","subtitle":"aj-z","contentWrap":"bj-z","imgWrap":"cj-z","heading":"dj-z","copy":"ej-z"};